import { getFilePreviewRoute } from "@certa/common/utils/routes";
import type { FilePreviewDetails } from "./FilePreviewerPage.types";

export const createFilePreviewUrl = ({
  url,
  fileName,
  highlightedText,
  filePreviewDataSource
}: FilePreviewDetails): string => {
  const baseUrl = getFilePreviewRoute();
  const searchParams = new URLSearchParams();

  // Add required parameters
  searchParams.set("url", encodeURIComponent(url));
  searchParams.set("fileName", encodeURIComponent(fileName));
  searchParams.set("dataSource", filePreviewDataSource);

  // Add optional parameter
  if (highlightedText) {
    searchParams.set("highlightedText", encodeURIComponent(highlightedText));
  }

  return `${baseUrl}?${searchParams.toString()}`;
};
